import { all, fork } from 'redux-saga/effects';

import emailSagas from './email/sagas';
import kakaoTalkSagas from './kakaoTalk/sagas';

export default function* sagas() {
  yield all([fork(emailSagas), fork(kakaoTalkSagas)]);
}
